import { SearchFn, requestVehicles } from "../../../../../../rest/Search";
import { Key } from "../../../../../../models";
import { FlagActions } from "../../../../../flux/Flag";
import { ErrorActions } from "../../../../../flux/Error";
import { EditSensorActions, EditSensorStoreState } from "../../flux";
import { Command, Command1 } from "../../../../../../Command";

export class LoadVehiclesCommand implements Command
{
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();
    private readonly editActions = new EditSensorActions();
    
    constructor(private search: SearchFn, private getState: () => EditSensorStoreState,
        private setVehicleCmd: Command1<Key>,
        private inProgressToken: string, private errorToken: string)
    {
    }
    
    execute = (): void => {
        const { editSession } = this.getState();
        const sameSession = () => editSession === this.getState().editSession;
        this.flagActions.set(this.inProgressToken);
        this.search(requestVehicles())
            .then(resp => {
                if(sameSession()) {
                    const { Vehicle: vehicles } = resp.Entries;
                    this.editActions.setVehicleItems(vehicles);

                    const { draft } = this.getState();
                    if(draft.VehicleId == null && vehicles.length === 1) {
                        this.setVehicleCmd.execute(vehicles[0].id);
                    }
                }
            })
            .catch(err => sameSession() && this.errorActions.setError(err, this.errorToken))
            .then(() => sameSession() && this.flagActions.reset(this.inProgressToken)); // finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/Vehicle/LoadVehiclesCommand.ts